module.exports = __webpack_public_path__ + "img/entrar-arrow.c27fa64b.svg";